/* eslint-disable import/order */
/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

// IMPORTANT: This import MUST be first - it sets __webpack_public_path__ before
// any other modules are evaluated. The publicPath.ts file has no imports itself,
// which is critical because ES6 imports are hoisted and executed before any code runs.
import './publicPath'

import { sharedEntryPoint } from '../../../modules/app/shared.entry'

import AdminconsoleApp from './app'

sharedEntryPoint(AdminconsoleApp)
